import { ReactElement } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react';

const KinnectPasswordValidationText = ({
  isValid,
  text,
}: {
  isValid: boolean;
  text: string;
}): ReactElement => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      {isValid ? (
        <CheckIcon
          sx={{
            height: 13,
            width: 13,
            paddingTop: 0.15,
            paddingLeft: 1,
            color: 'green',
          }}
        />
      ) : (
        <CloseIcon
          sx={{
            height: 13,
            width: 13,
            paddingTop: 0.15,
            paddingLeft: 1,
            color: 'red',
          }}
        />
      )}
      <Typography
        sx={{
          fontFamily: 'EdmondsansMedium',
          fontSize: 12,
          textAlign: 'left',
          paddingLeft: 1,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default observer(KinnectPasswordValidationText);
